import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

// Um arquivo pendente é {nome, situacao, detalhe, dataEnvio}. A forma antiga — lista de
// strings — ainda chega de um Web que não tenha subido junto, e é convertida aqui para as
// telas não precisarem saber de qual versão vieram.
const normalizarPendentes = arquivos => (arquivos || []).map(a => (
  typeof a === 'string' ? { nome: a, situacao: '', detalhe: '', dataEnvio: '' } : a
));

const normalizarEnvio = dados => ({
  arquivos: normalizarPendentes(dados && dados.arquivos),
  isaacConfigurado: !(dados && dados.isaacConfigurado === false),
  motivoIsaac: (dados && dados.motivoIsaac) || '',
});

export default {
  iniciarSessao: token => {
    return Vue.http.post('/api/acessoConciliacao/Sessao', { token })
      .then(resposta => resposta.data);
  },
  lista: (pagina = 1, filtros = {}, todos = false) => {
    const parametros = Object.assign({}, { pagina, todos }, filtros);
    return Vue.http.get('/api/conciliacaoProjeto', { params: parametros })
      .then(resposta => resposta.data);
  },
  projetos: (todos = false, situacaoProjeto = 0) => {
    return Vue.http.get('/api/conciliacaoProjeto/Projetos', { params: { todos, situacaoProjeto } })
      .then(resposta => resposta.data);
  },
  exportarLista: (filtros = {}, todos = false) => {
    const parametros = Object.assign({}, { todos }, filtros);
    return Vue.http.get('/api/conciliacaoProjeto/Exportar', { params: parametros })
      .then(resposta => resposta.data);
  },
  responsaveis: () => {
    return Vue.http.get('/api/conciliacaoProjeto/Responsaveis')
      .then(resposta => resposta.data);
  },
  previaProcessamento: (reprocessarTudo = false, todos = false) => {
    return Vue.http.get('/api/conciliacaoProjeto/Processar', { params: { reprocessarTudo, todos } })
      .then(resposta => resposta.data);
  },
  processarProjetos: (cursor = 0, reprocessarTudo = false, todos = false) => {
    return Vue.http.post('/api/conciliacaoProjeto/Processar', {}, { params: { cursor, reprocessarTudo, todos } })
      .then(resposta => resposta.data);
  },
  configuracaoProjeto: () => {
    return Vue.http.get('/api/conciliacaoProjeto/Configuracao')
      .then(resposta => resposta.data);
  },
  salvarConfiguracaoProjeto: payload => {
    return Vue.http.post('/api/conciliacaoProjeto/Configuracao', payload)
      .then(resposta => resposta.data);
  },
  listaBanco: (pagina = 1, filtros = {}, todos = false) => {
    const parametros = Object.assign({}, { pagina, todos }, filtros);
    return Vue.http.get('/api/conciliacaoBanco', { params: parametros })
      .then(resposta => resposta.data);
  },
  sugestoesTextoAplicacao: () => {
    return Vue.http.get('/api/conciliacaoBanco/TextosAplicacao')
      .then(resposta => resposta.data);
  },
  confirmarTextosAplicacao: textos => {
    return Vue.http.post('/api/conciliacaoBanco/TextosAplicacao/Confirmar', { textos })
      .then(resposta => resposta.data);
  },
  rejeitarTextosAplicacao: textos => {
    return Vue.http.post('/api/conciliacaoBanco/TextosAplicacao/Rejeitar', { textos })
      .then(resposta => resposta.data);
  },
  previaProcessamentoBanco: () => {
    return Vue.http.get('/api/conciliacaoBanco/Processar')
      .then(resposta => resposta.data);
  },
  processarBanco: (cursor = 0) => {
    return Vue.http.post('/api/conciliacaoBanco/Processar', {}, { params: { cursor } })
      .then(resposta => resposta.data);
  },
  contas: (todos = false) => {
    return Vue.http.get('/api/conciliacaoBanco/Contas', { params: { todos } })
      .then(resposta => resposta.data);
  },
  ignoradas: (filtros = {}, todos = false) => {
    const parametros = Object.assign({}, { todos }, filtros);
    return Vue.http.get('/api/conciliacaoBanco/Ignoradas', { params: parametros })
      .then(resposta => resposta.data);
  },
  contexto: (idProjetoCript, dataIni = '', dataFim = '') => {
    return Vue.http.get(`/api/conciliacaoProjeto/${idProjetoCript}/Contexto`, { params: { dataIni, dataFim } })
      .then(resposta => resposta.data);
  },
  dados: (idProjetoCript, dataIni = '', dataFim = '', processar = false) => {
    return Vue.http.get(`/api/conciliacaoProjeto/${idProjetoCript}/Dados`, { params: { dataIni, dataFim, processar } })
      .then(resposta => resposta.data);
  },
  conciliar: (idProjetoCript, payload) => {
    return Vue.http.post(`/api/conciliacaoProjeto/${idProjetoCript}/Conciliar`, payload)
      .then(resposta => resposta.data);
  },
  rateios: (idProjetoCript, idLancamento) => {
    return Vue.http.get(`/api/conciliacaoProjeto/${idProjetoCript}/Rateios`, { params: { idLancamento } })
      .then(resposta => resposta.data);
  },
  desfazer: (idProjetoCript, grupo) => {
    return Vue.http.post(`/api/conciliacaoProjeto/${idProjetoCript}/Desfazer`, { grupo })
      .then(resposta => resposta.data);
  },
  observacao: (idProjetoCript, payload) => {
    return Vue.http.post(`/api/conciliacaoProjeto/${idProjetoCript}/Observacao`, payload)
      .then(resposta => resposta.data);
  },
  contextoBanco: idContaCript => {
    return Vue.http.get(`/api/conciliacaoProjeto/${idContaCript}/ContextoBanco`)
      .then(resposta => resposta.data);
  },
  dadosBanco: (idProjetoCript, dataIni = '', dataFim = '', processar = false, limite = 0) => {
    return Vue.http.get(`/api/conciliacaoProjeto/${idProjetoCript}/DadosBanco`, { params: { dataIni, dataFim, processar, limite } })
      .then(resposta => resposta.data);
  },
  contasReceberOutrasContas: (idContaCript, busca = '', valor = 0, dataFim = '') => {
    return Vue.http.get(`/api/conciliacaoProjeto/${idContaCript}/ContasReceberOutrasContas`, { params: { busca, valor, dataFim } })
      .then(resposta => resposta.data);
  },
  checkTaxa: (idContaCript, payload) => {
    return Vue.http.post(`/api/operacaoConciliacao/${idContaCript}/CheckTaxa`, payload)
      .then(resposta => resposta.data);
  },
  conciliarBanco: (idProjetoCript, payload) => {
    return Vue.http.post(`/api/conciliacaoProjeto/${idProjetoCript}/ConciliarBanco`, payload)
      .then(resposta => resposta.data);
  },
  desfazerBanco: (idProjetoCript, grupo) => {
    return Vue.http.post(`/api/conciliacaoProjeto/${idProjetoCript}/DesfazerBanco`, { grupo })
      .then(resposta => resposta.data);
  },
  observacaoBanco: (idProjetoCript, payload) => {
    return Vue.http.post(`/api/conciliacaoProjeto/${idProjetoCript}/ObservacaoBanco`, payload)
      .then(resposta => resposta.data);
  },
  extratosPendentes: idProjetoCript => {
    return Vue.http.get(`/api/conciliacaoProjeto/${idProjetoCript}/ExtratosPendentes`)
      .then(resposta => normalizarEnvio(resposta.data));
  },
  enviarExtratos: (idProjetoCript, arquivos) => {
    return Vue.http.post(`/api/conciliacaoProjeto/${idProjetoCript}/EnviarExtratos`, { arquivos })
      .then(resposta => resposta.data);
  },
  diaUtilAnterior: () => {
    return Vue.http.get('/api/conciliacaoProjeto/DiaUtilAnterior')
      .then(resposta => resposta.data);
  },
  configuracaoAnexos: () => {
    return Vue.http.get('/api/anexoConciliacao/Configuracao')
      .then(resposta => resposta.data);
  },
  enviarAnexos: (destino, ids, arquivos) => {
    const dados = new FormData();

    dados.append('ids', (ids || []).filter(i => i > 0).join(','));
    (arquivos || []).forEach(a => dados.append('arquivos', a, a.name));

    return Vue.http.post(`/api/anexoConciliacao/${destino}`, dados)
      .then(resposta => resposta.data);
  },
  configuracaoCredito: () => {
    return Vue.http.get('/api/creditoIdentificar/Configuracao')
      .then(resposta => resposta.data);
  },
  textosPadrao: () => {
    return Vue.http.get('/api/creditoIdentificar/TextosPadrao')
      .then(resposta => resposta.data);
  },
  salvarTextosPadrao: payload => {
    return Vue.http.post('/api/creditoIdentificar/TextosPadrao', payload)
      .then(resposta => resposta.data);
  },
  salvarConfiguracaoCredito: payload => {
    return Vue.http.post('/api/creditoIdentificar/Configuracao', payload)
      .then(resposta => resposta.data);
  },
  contasCredito: (idProjeto = 0, busca = '') => {
    return Vue.http.get('/api/creditoIdentificar/Contas', { params: { idProjeto, busca } })
      .then(resposta => resposta.data);
  },
  projetosCredito: (busca = '') => {
    return Vue.http.get('/api/creditoIdentificar/Projetos', { params: { busca } })
      .then(resposta => resposta.data);
  },
  rubricasCredito: (idProjeto = 0, busca = '', natureza = 'C') => {
    return Vue.http.get('/api/creditoIdentificar/Rubricas', { params: { idProjeto, busca, natureza } })
      .then(resposta => resposta.data);
  },
  subrubricasCredito: (idProjeto = 0, idRubrica = 0, busca = '', natureza = 'C') => {
    return Vue.http.get('/api/creditoIdentificar/Subrubricas', { params: { idProjeto, idRubrica, busca, natureza } })
      .then(resposta => resposta.data);
  },
  contasGerais: (busca = '', excluirTransitorias = false) => {
    return Vue.http.get('/api/creditoIdentificar/ContasGerais', { params: { busca, excluirTransitorias } })
      .then(resposta => resposta.data);
  },
  rubricasGerais: (busca = '', natureza = 'D') => {
    return Vue.http.get('/api/creditoIdentificar/RubricasGerais', { params: { busca, natureza } })
      .then(resposta => resposta.data);
  },
  subrubricasGerais: (idRubrica = 0, busca = '', natureza = 'D') => {
    return Vue.http.get('/api/creditoIdentificar/SubrubricasGerais', { params: { idRubrica, busca, natureza } })
      .then(resposta => resposta.data);
  },
  pessoasCredito: (busca = '', tipoPessoa = 0) => {
    return Vue.http.get('/api/creditoIdentificar/Pessoas', { params: { busca, tipoPessoa } })
      .then(resposta => resposta.data);
  },
  categoriasFinanceiras: (busca = '') => {
    return Vue.http.get('/api/creditoIdentificar/CategoriasFinanceiras', { params: { busca } })
      .then(resposta => resposta.data);
  },
  impactoCorte: (data = '') => {
    return Vue.http.get('/api/creditoIdentificar/ImpactoCorte', { params: { data } })
      .then(resposta => resposta.data);
  },
  regularizarCredito: (idContaCript, payload) => {
    return Vue.http.post(`/api/creditoIdentificar/${idContaCript}/Regularizar`, payload)
      .then(resposta => resposta.data);
  },
  debitoTransitoria: (idContaCript, idLancamento) => {
    return Vue.http.get(`/api/creditoIdentificar/${idContaCript}/DebitoTransitoria`, { params: { idLancamento } })
      .then(resposta => resposta.data);
  },
  regularizarTransitoria: (idContaCript, payload) => {
    return Vue.http.post(`/api/creditoIdentificar/${idContaCript}/RegularizarTransitoria`, payload)
      .then(resposta => resposta.data);
  },
  glossarioIA: (numeroBanco = '') => {
    return Vue.http.get('/api/creditoIdentificar/Glossario', { params: { numeroBanco } })
      .then(resposta => resposta.data);
  },
  salvarGlossarioIA: payload => {
    return Vue.http.post('/api/creditoIdentificar/Glossario', payload)
      .then(resposta => resposta.data);
  },
  bancosGlossarioIA: () => {
    return Vue.http.get('/api/creditoIdentificar/GlossarioBancos')
      .then(resposta => resposta.data);
  },
  responderSugestaoIA: (idContaCript, payload) => {
    return Vue.http.post(`/api/conciliacaoProjeto/${idContaCript}/SugestaoIA`, payload)
      .then(resposta => resposta.data);
  },
  detectarOperacao: (idContaCript, idExtrato) => {
    return Vue.http.get(`/api/operacaoConciliacao/${idContaCript}/Detectar`, { params: { idExtrato } })
      .then(resposta => resposta.data);
  },
  aplicacoesConta: (idContaCript, busca = '') => {
    return Vue.http.get(`/api/operacaoConciliacao/${idContaCript}/Aplicacoes`, { params: { busca } })
      .then(resposta => resposta.data);
  },
  contasOperacao: (idContaCript, busca = '') => {
    return Vue.http.get(`/api/operacaoConciliacao/${idContaCript}/Contas`, { params: { busca } })
      .then(resposta => resposta.data);
  },
  tiposAplicacao: (busca = '') => {
    return Vue.http.get('/api/operacaoConciliacao/TiposAplicacao', { params: { busca } })
      .then(resposta => resposta.data);
  },
  codigoProjetoConta: (idContaCript, idContaAlvo) => {
    return Vue.http.get(`/api/operacaoConciliacao/${idContaCript}/CodigoProjetoConta`, { params: { idContaAlvo } })
      .then(resposta => resposta.data.codigo || '');
  },
  tiposAplicacaoConta: (idContaCript, busca = '') => {
    return Vue.http.get(`/api/operacaoConciliacao/${idContaCript}/TiposAplicacao`, { params: { busca } })
      .then(resposta => resposta.data);
  },
  transferirEntreContas: (idContaCript, payload) => {
    return Vue.http.post(`/api/operacaoConciliacao/${idContaCript}/Transferir`, payload)
      .then(resposta => resposta.data);
  },
  solicitarTransferencia: (idContaCript, payload) => {
    return Vue.http.post(`/api/operacaoConciliacao/${idContaCript}/SolicitarTransferencia`, payload)
      .then(resposta => resposta.data);
  },
  usuariosLiberacao: (busca = '') => {
    return Vue.http.get('/api/operacaoConciliacao/Usuarios', { params: { busca } })
      .then(resposta => resposta.data);
  },
  projetosDaConta: (idContaCript, busca = '', natureza = 'C', idContaAlvo = 0) => {
    return Vue.http.get(`/api/operacaoConciliacao/${idContaCript}/ProjetosConta`, { params: { busca, natureza, idContaAlvo } })
      .then(resposta => resposta.data);
  },
  regraCategoria: (idContaCript) => {
    return Vue.http.get(`/api/operacaoConciliacao/${idContaCript}/RegraCategoria`)
      .then(resposta => resposta.data);
  },
  itensControle: (idContaCript, idProjeto = 0, idRubrica = 0, idSubRubrica = 0, busca = '') => {
    return Vue.http.get(`/api/operacaoConciliacao/${idContaCript}/ItensControle`,
                        { params: { idProjeto, idRubrica, idSubRubrica, busca } })
      .then(resposta => resposta.data);
  },
  lancarMovimento: (idContaCript, payload) => {
    return Vue.http.post(`/api/operacaoConciliacao/${idContaCript}/Movimento`, payload)
      .then(resposta => resposta.data);
  },
  lancarContaReceberConta: (idContaCript, payload) => {
    return Vue.http.post(`/api/operacaoConciliacao/${idContaCript}/ContaReceber`, payload)
      .then(resposta => resposta.data);
  },
  lancarAplicacao: (idContaCript, payload) => {
    return Vue.http.post(`/api/operacaoConciliacao/${idContaCript}/Aplicacao`, payload)
      .then(resposta => resposta.data);
  },
  lancarResgate: (idContaCript, payload) => {
    return Vue.http.post(`/api/operacaoConciliacao/${idContaCript}/Resgate`, payload)
      .then(resposta => resposta.data);
  },
  extratoContasLista: () => {
    return Vue.http.get('/api/conciliacaoProjeto/ExtratoContas')
      .then(resposta => normalizarEnvio(resposta.data));
  },
  extratoContasResumo: () => {
    return Vue.http.get('/api/conciliacaoProjeto/ExtratoContas/Resumo')
      .then(resposta => resposta.data);
  },
  enviarExtratoContas: arquivos => {
    return Vue.http.post('/api/conciliacaoProjeto/ExtratoContas', { arquivos })
      .then(resposta => resposta.data);
  },
  cabecalhoTesouraria: (horizonte = 1, ateData = '') => {
    return Vue.http.get('/api/posicaoTesouraria/Cabecalho', { params: { horizonte, ateData } })
      .then(resposta => resposta.data);
  },
  posicaoTesouraria: (pagina = 1, filtros = {}) => {
    const parametros = Object.assign({}, { pagina }, filtros);
    return Vue.http.get('/api/posicaoTesouraria', { params: parametros })
      .then(resposta => resposta.data);
  },
  exportarPosicaoTesouraria: (filtros = {}) => {
    return Vue.http.get('/api/posicaoTesouraria/Exportar', { params: filtros })
      .then(resposta => resposta.data);
  },
  contasTesouraria: () => {
    return Vue.http.get('/api/posicaoTesouraria/Contas')
      .then(resposta => resposta.data);
  },
  projetosTesouraria: () => {
    return Vue.http.get('/api/posicaoTesouraria/Projetos')
      .then(resposta => resposta.data);
  },
  detalheTesouraria: (idContaCript, dataReferencia = '', horizonte = 1, ateData = '') => {
    return Vue.http.get('/api/posicaoTesouraria/' + encodeURIComponent(idContaCript), { params: { dataReferencia, horizonte, ateData } })
      .then(resposta => resposta.data);
  },
  configuracaoTesouraria: () => {
    return Vue.http.get('/api/posicaoTesouraria/Configuracao')
      .then(resposta => resposta.data);
  },
  salvarConfiguracaoTesouraria: payload => {
    return Vue.http.post('/api/posicaoTesouraria/Configuracao', payload)
      .then(resposta => resposta.data);
  },
  compromissosTesouraria: (idContaCript, dataReferencia = '', horizonte = 1, ateData = '') => {
    return Vue.http.get('/api/posicaoTesouraria/' + encodeURIComponent(idContaCript) + '/Compromissos', { params: { dataReferencia, horizonte, ateData } })
      .then(resposta => resposta.data);
  },
  tratarTesouraria: (idContaCript, dataReferencia, observacao) => {
    return Vue.http.post('/api/posicaoTesouraria/' + encodeURIComponent(idContaCript) + '/Tratada', { dataReferencia, observacao })
      .then(resposta => resposta.data);
  },
  aplicacoesConta: idContaCript => {
    return Vue.http.get('/api/aplicacaoConta/' + encodeURIComponent(idContaCript))
      .then(resposta => resposta.data);
  },
  extratoAplicacao: (idContaCript, idAplicacao, de = '', ate = '') => {
    return Vue.http.get('/api/aplicacaoConta/' + encodeURIComponent(idContaCript) + '/' + idAplicacao, { params: { de, ate } })
      .then(resposta => resposta.data);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/conciliacao-projeto/servico.js